
export * from '../../item-selector-web/__liferay__/index.js';
